

// 法人,事業所のShortNameは大文字、英字、数字のみ
export const IsShortNameValid = (shortName) => {
  const regex = new RegExp('^[A-Z0-9]+$')
  const result = regex.test(shortName)

  return result
}

// 符号無し整数チェック
export const isInteger = (value) => {
  const regex = new RegExp('^[0-9]+$')
  const result = regex.test(value)
  return result
}